import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromBetong } from "@/components/calculators/lineMappers";
import { betongCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/betong")({
  component: BetongPage,
});

function BetongPage() {
  const [lengde, setLengde] = useState<number | "">("");
  const [bredde, setBredde] = useState<number | "">("");
  const [tykkelse, setTykkelse] = useState<number | "">(100);
  const [spill, setSpill] = useState<number | "">(5);

  const r = useMemo(() => {
    if (lengde === "" || bredde === "" || tykkelse === "") return null;
    return betongCalc({
      lengde_m: Number(lengde),
      bredde_m: Number(bredde),
      tykkelse_mm: Number(tykkelse),
      spill_pct: spill === "" ? undefined : Number(spill),
    });
  }, [lengde, bredde, tykkelse, spill]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Betong" subtitle="Beregn betongvolum og antall sekker (25 kg)." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Volum",         value: `${fmt(r.volum_m3, 2)} m³`, strong: true },
              { label: "Sekker à 25 kg", value: `${fmt(r.sekker_25kg, 0)} stk` },
            ]}
            note="~2000 kg/m³ tørr betong. For større støper – bestill ferdigbetong."
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Betong`} lines={linesFromBetong(r)} defaultLaborHours={Math.max(0, Math.round((r.volum_m3 * 4) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn mål.</div>}
      >
        <Field label="Lengde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="Bredde" unit="m"><NumberInput value={bredde} onChange={setBredde} /></Field>
        <Field label="Tykkelse" unit="mm"><NumberInput value={tykkelse} onChange={setTykkelse} /></Field>
        <Field label="Svinn" unit="%"><NumberInput value={spill} onChange={setSpill} /></Field>
      </CalcShell>
    </>
  );
}
